import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>Is there objective medical evidence in the medical record to support the need for enteral nutrition? For example: Malnutrition documented by serum protein levels, albumin levels or hemoglobin, changes in skin or bones, or physiological disorders resulting from surgery.</p>
				<div className="toggle">
					<div className={this.props.data.MedicalEvidence   == 'Y' ? 'Selected' : 'NotSelected' } onClick={(e)=>{this.props.setData('MedicalEvidence', 'Y')}}>Yes</div>
					<div className={this.props.data.MedicalEvidence   == 'N' ? 'Selected' : 'NotSelected' } onClick={(e)=>{this.props.setData('MedicalEvidence', 'N')}}>No</div>
				</div>
				
						<br/>
				
				<div className="button" onClick={()=>this.props.navigate( this.props.data.MedicalEvidence == "Y" ? 'R24A' : 'R24B' )}>Continue</div>
			</div>
		);
		
	}
}